import { inject, Injectable, signal } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ForbiddenService {
  private readonly _isForbidden = signal(false);
  readonly isForbidden = this._isForbidden.asReadonly();

  constructor() {
    inject(Router).events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe(() => {
      this._isForbidden.set(false);
    });
  }

  setForbidden(): void {
    this._isForbidden.set(true);
  }

  /**
   * Clear the flag without navigating.
   *
   * Until now the only way out of the denied state was a NavigationStart, which was enough when a
   * 403 meant "you may never see this page". The client-scoped reports (367917) can recover in
   * place: a Reader who lands on one with no client selected gets a 403, then picks a client and
   * reloads on the same route. Without this the page would keep showing the denied panel over data
   * it is now allowed to read.
   */
  clearForbidden(): void {
    this._isForbidden.set(false);
  }
}
